import {Exclude, Expose, Type} from "class-transformer";
import {AbstractApiModel} from "./abstract.api.model";
import {UserApiModel} from "./user.api-model";
import {MarketplaceAdvertisementApiModel} from "./marketplace-advertisement.api.model";
import {ChatMessageApiModel} from "./chat-message.api.model";

@Exclude()
export class ConversationApiModel extends AbstractApiModel {
  @Expose() public id: string;
  @Expose()
  @Type(() => UserApiModel)
  public userOne: UserApiModel;
  @Expose()
  @Type(() => UserApiModel)
  public userTwo: UserApiModel;
  @Expose()
  @Type(() => MarketplaceAdvertisementApiModel)
  public listing?: MarketplaceAdvertisementApiModel|string;
  @Expose()
  @Type(() => ChatMessageApiModel)
  public lastMessage?: ChatMessageApiModel;
  @Expose() public lastMessageAt?: Date;
  @Expose() public lastReadAtUserOne?: Date;
  @Expose() public lastReadAtUserTwo?: Date;
  @Expose() public createdAt?: Date;
  @Expose() public updatedAt?: Date;
}
